import styled from 'styled-components';

export const StyledAlarmModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px;
`;
